import { create } from 'zustand';

interface AddVulOnMapModalState {
  isOpen: boolean;
  objectSlug: string;
  planSlug: string;
  onManageAddVulOnMapClose: () => void;
  onManageAddVulOnMapOpen: (objectSlug: string, planSlug: string) => void;
}

export const useAddVulOnMapModalStore = create<AddVulOnMapModalState>(set => ({
  isOpen: false,
  objectSlug: '',
  planSlug: '',
  onManageAddVulOnMapClose: () => set({ isOpen: false, objectSlug: '', planSlug: '' }),
  onManageAddVulOnMapOpen: (objectSlug: string, planSlug: string) => set({ isOpen: true, objectSlug, planSlug }),
}));
